import React from "react";

const DateAndLocation = (props) => {
    const {label , fieldValue, iconClass} = props;
  return (
    <p className="mb-0">
      <strong className="color-brand">
        <i className={`${iconClass} me-2 color-brand`}></i>{label}:
      </strong>{" "}
      {fieldValue}
    </p>
  );
};

export default DateAndLocation;
